import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
import { FuseConfigService } from '../../../../../core/services/config.service';
import { fuseAnimations } from '../../../../../core/animations';
import { FuseNavigationModel } from '../../../../../navigation/navigation.model';
import { FuseNavigationService } from '../../../../../core/components/navigation/navigation.service';
import { FuseTranslationLoaderService } from '../../../../../core/services/translation-loader.service';
import { locale as navigationEnglish } from '../../../../../navigation/i18n/en';
import { locale as navigationTurkish } from '../../../../../navigation/i18n/tr';

//Query File
import { UserQueryService } from '../../queryFiles/index';

/**Local files */
import { spekwo, login, toastMsg } from '../../utils/index';

/** Local component */
import { ToastComponent } from '../../common/toast.component';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    animations: fuseAnimations
})

export class LoginComponent implements OnInit {

    spekwoValues = spekwo;
    loginValues = login;
    toastMsg = toastMsg;

    loginForm: FormGroup;
    loginFormErrors: any;
    getLoginCredentials: any;
    isResults = false;
    hide = true;
    userQueryServiceSubscription: Subscription;

    constructor(
        private fuseConfig: FuseConfigService,
        private fuseNavigationService: FuseNavigationService,
        private translate: TranslateService,
        private translationLoader: FuseTranslationLoaderService,
        private formBuilder: FormBuilder,
        private router: Router,

        public toastComponent: ToastComponent,
        /** Query file */
        public userQueryService: UserQueryService
    ) {

        this.fuseConfig.setSettings({
            layout: {
                toolbar: 'none',
                footer: 'none'
            }
        });

        this.loginFormErrors = {
            username: {},
            password: {}
        };
        // Add languages
        this.translate.addLangs(['en', 'tr']);

        // Set the default language
        this.translate.setDefaultLang('en');

        // Use a language
        this.translate.use('en');
        this.translationLoader.loadTranslations(navigationEnglish, navigationTurkish);
    }

    ngOnInit() {

        this.loginForm = this.formBuilder.group({
            username: ['', [Validators.required, Validators.pattern]],
            password: ['', Validators.required]
        });
        this.loginForm.valueChanges.subscribe(() => {
            this.onLoginFormValuesChanged();
        });

    }

    ngOnDestroy() {
        this.userQueryServiceSubscription && this.userQueryServiceSubscription.unsubscribe();
    }

    onLoginFormValuesChanged() {

        for (const field in this.loginFormErrors) {

            if (field == 'username') {
                this.loginForm.value.username = this.loginForm.value.username.trim().toLowerCase()
            }

            if (!this.loginFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.loginFormErrors[field] = {};

            // Get the control
            const control = this.loginForm.get(field);
            if (control && control.dirty && !control.valid) {
                this.loginFormErrors[field] = control.errors;
            }

        }
    }

    //after login
    login() {

        this.isResults = true;

        this.userQueryServiceSubscription = this.userQueryService.LOGIN(this.loginForm.value)
            .valueChanges
            .subscribe(({ data }) => {

                if (data.allUsers && data.allUsers.edges.length > 0) {
                    /** Based on role set navigation  */

                    if (data.allUsers.edges[0].node.roleByRoleId.roleName != this.spekwoValues.Pro) {

                        // Set the navigation model
                        this.fuseNavigationService.setNavigationModel(new FuseNavigationModel());

                        setTimeout(() => {
                            this.router.navigate(['apps/e-commerce/orders']);
                        }, 10);

                        window.localStorage.setItem("userUID", data.allUsers.edges[0].node.userId);
                        window.localStorage.setItem("role", data.allUsers.edges[0].node.roleByRoleId.roleName);

                        this.toastComponent.showToast(this.toastMsg.loginSuccess);


                    } else {

                        this.toastComponent.showToast(this.toastMsg.loginFailed);
                    }

                    this.isResults = false;
                }
                else {

                    this.toastComponent.showToast(this.toastMsg.loginInvalid);
                    this.isResults = false;

                }
            }, () => {
                this.toastComponent.showToast(this.toastMsg.networkError);
                this.isResults = false;
            })
    }

}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/authentication/login/login.component.ts